export default {
    previous: { en: "Previous", ne: "अघिल्लो" },
    next: { en: "Next", ne: "अर्को" },
    today: { en: "Today", ne: "आज" },
}
